import { createStore } from 'satcheljs';
import GroupsState from './schema/GroupsState';
import GroupInformation from './schema/GroupInformation';
import { ObservableMap } from 'mobx';

export const getGroupsStore = createStore<GroupsState>('groupsStore', {
    groups: new ObservableMap<string, GroupInformation>(),
});
